<script setup>

</script>

<template>
  <div class="products__box">
    <h3>Ищите другие<br/> продукты  ХРУТКА<sup>®</sup></h3>
    <p>Сканируйте QR-коды на упаковках<br/> и смотрите новые ХРУТЫЕ УРОКИ!</p>
    <img :src="require('@/assets/img/products.png')" alt="" class="products__packs"/>
  </div>
</template>